<script>
	import Sucursales from "../../plugins/Sucursales.vue";

	export default {
		components: { Sucursales },
		props: {
			url: { type: String, required: true },
			id: { type: String, required: true },
			conector: { type: String, required: true },
			sgl: { type: Number, default: 0 },
			dbl: { type: Number, default: 0 },
			dbb: { type: Number, default: 0 },
			tpl: { type: Number, default: 0 },
			salida: { type: String, default: '' },
			categoria: { type: String, default: '' },
			habitaciones: { type: String, default: '' },
			sucursales: { type: Boolean, required: true },
			nochesPre: { type: Number, default: 0 },
			nochesPos: { type: Number, default: 0 },
			servicioList: { type: Array, default: [] },
			// Exclusivos VPT
			idioma: { type: Number, required: true },
			pickup: { type: String, required: true },
			regimen: { type: Number, required: true },
			trasladoIn: { type: Number, required: true },
			trasladoOut: { type: Number, required: true },
		},
		computed: {
			actionURL() {
				return `${this.url}/services/circuitos/consultar/${this.conector}/${this.id}`;
			}
		}
	};
</script>

<template>
	<form method="POST" :action="actionURL" id="formulario_consulta">
		<input type="hidden" name="id" v-bind:value="id" />
		<input type="hidden" name="conector" v-bind:value="conector" />

		<input type="hidden" name="sgl" v-bind:value="sgl" />
		<input type="hidden" name="dbl" v-bind:value="dbl" />
		<input type="hidden" name="dbb" v-bind:value="dbb" />
		<input type="hidden" name="tpl" v-bind:value="tpl" />
		<input type="hidden" name="salida" v-bind:value="salida" />
		<input type="hidden" name="categoria" v-bind:value="categoria" />
		<input type="hidden" name="habitaciones" v-bind:value="habitaciones" />
		<input type="hidden" name="nochesPre" v-bind:value="nochesPre" />
		<input type="hidden" name="nochesPos" v-bind:value="nochesPos" />
		<input v-for="(servicio, index) in servicioList" :key="servicio" type="hidden" :name="'servicioList['+ index +']'" v-bind:value="servicio" />
		<!-- Exclusivos VPT -->
		<input type="hidden" name="idioma" v-bind:value="idioma" />
		<input type="hidden" name="regimen" v-bind:value="regimen" />
		<input type="hidden" name="pickup" v-bind:value="pickup" />
		<input type="hidden" name="traslado_in" v-bind:value="trasladoIn" />
		<input type="hidden" name="traslado_out" v-bind:value="trasladoOut" />

		<div class="page-header">
			<h3>
				<i class="fa fa-check-circle"></i>
				<span v-html="'Informaci&oacute;n de contacto'"></span>
			</h3>
		</div>

		<div class="panel panel-default panel-form">
			<div class="panel-heading">
				<h3 class="panel-title">
					<i class="fa fa-phone"></i>
					Contacto
				</h3>
			</div>

			<div class="list-group">
				<div class="list-group-item">
					<div class="row row-20">
						<div class="col-xs-12 col-sm-6">
							<div class="form-group">
								<label for="nombre">Nombre y Apellido</label>
								<input
									type="text"
									class="form-control input-sm"
									id="nombre"
									name="nombre"
									required
									autocomplete="off"
								/>
							</div>
						</div>

						<div class="col-xs-12 col-sm-6">
							<div class="form-group">
								<label for="email">E-mail</label>
								<input
									type="text"
									class="form-control input-sm"
									id="email"
									name="email"
									required
									autocomplete="off"
								/>
							</div>
						</div>
					</div>
				</div>

				<div class="list-group-item">
					<div class="row row-20">
						<div class="col-xs-12 col-sm-6">
							<div class="form-group">
								<label for="telefono" v-html="'Tel&eacute;fono'"></label>
								<input
									type="text"
									class="form-control input-sm"
									id="telefono"
									name="telefono"
									required
									autocomplete="off"
								/>
							</div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div class="form-group">
								<label for="direccion" v-html="'Direcci&oacute;n'"></label>
								<input
									type="text"
									class="form-control input-sm"
									id="direccion"
									name="direccion"
									required
									autocomplete="off"
								/>
							</div>
						</div>
					</div>
				</div>

				<div class="list-group-item">
					<div class="row row-20">
						<div class="col-xs-12 col-sm-6">
							<div class="form-group">
								<label for="pais" v-html="'Pa&iacute;s'"></label>
								<input
									type="text"
									class="form-control input-sm"
									id="pais"
									name="pais"
									required
									autocomplete="off"
								/>
							</div>
						</div>

						<div class="col-xs-12 col-sm-6">
							<div class="form-group">
								<label for="ciudad">Ciudad</label>
								<input
									type="text"
									class="form-control input-sm"
									id="ciudad"
									name="ciudad"
									required
									autocomplete="off"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Sucursales -->
		<div v-if="sucursales">
			<div class="page-header">
				<h3>
					<i class="fa fa-address-book-o"></i>
					Vendedor & Sucursal
				</h3>
			</div>
			<sucursales sm="CIR" :url="url" :post_sucursal="0" :post_vendedor="0"></sucursales>
		</div>

		<hr />
		<div class="panel panel-default panel-form">
			<div class="panel-heading">
				<h3 class="panel-title">
					<i class="fa fa-pencil-square-o"></i>
					Observaciones
				</h3>
			</div>
			<div class="list-group">
				<div class="list-group-item">
					<div class="row">
						<div class="col-xs-12">
							<div class="form-group">
								<label for="comentarios">Comentarios:</label>
								<textarea class="form-control" rows="5" name="comentarios" id="comentarios" placeholder></textarea>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<hr />
		<div class="row row-20">
			<div class="col-xs-12 col-sm-3 col-sm-offset-9">
				<button type="submit" class="btn btn-success btn-block">
					CONSULTAR
					<i class="fa fa-envelope"></i>
				</button>
			</div>
		</div>
	</form>
</template>

<style scoped>
	form#formulario_consulta {margin-bottom: 20px;}
</style>